import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/crm/customer-order/{id}/reject`。body：`rejectReason`、`updatedAt`。 */
export async function rejectCustomerOrder(id, payload) {
  const { data: raw } = await request.post(
    `/crm/customer-order/${id}/reject`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
